import { FormikErrors } from 'formik';
import Translation from '../../i18n/models/translation';

export const getDate = (created_at: string) => {
  const date = new Date(created_at);
  const day = String(date.getDate());
  const month = getMonth(date.getMonth());
  const year = String(date.getFullYear());
  const hours = String(date.getHours());
  const mins =
      date.getMinutes() < 10
          ? `0${String(date.getMinutes())}`
          : String(date.getMinutes());

  return `${day} de ${month} de ${year}, ${hours}:${mins}`;
};

export const formatDate = (date: Date) => {
  const day = String(date.getDate());
  const month = String(date.getMonth() + 1);
  const year = String(date.getFullYear());

  return `${year}-${month}-${day}`;
};

export const getMonths = () => {
  return [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ];
};

export const range = (numA: number, numB: number) => {
  const res = [];
  for (let i = numA; i <= numB; i++) {
    res.push(i);
  }
  return res;
};

const getMonth = (num: number): string => {
  const months = getMonths();
  return months[num];
};

export const getErrorMessage = (statusCode: number, text: any) => {
  if (statusCode >= 400 && statusCode < 500) {
    return text.clientError;
  }
  return text.serverError;
};
export const getCurrentYear = () => {
  return new Date().getFullYear();
};

export function hasKey(obj: FormikErrors<unknown>, key: string) {
  return key in obj;
}
